import { Box, Flex, Text } from "@chakra-ui/react";
import { faTriangleExclamation } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "@morressier/alembic";

type IProps = {
	isOpen: boolean;
	onClose: () => void;
	handleLeaveTabChange: () => void
}


const ConfirmLeavePageModal = ({ isOpen, onClose, handleLeaveTabChange }: IProps) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			width="448px"
			closeButtonProps={{
				hidden: true
			}}
		>
			<Flex direction={'column'} padding={6} gap={3}>
				<Box>
					<FontAwesomeIcon icon={faTriangleExclamation} size='2x' />
				</Box>
				<Text textStyle='headingGroup'>Leave Page?</Text>
				<Text>You have unsaved changes. Are you sure you want to leave this page?</Text>
				<Flex gap={3} justifyContent={'flex-end'}>
					<Button onClick={onClose}>Cancel</Button>
					<Button variant="caution" onClick={handleLeaveTabChange}>Leave Page</Button>
				</Flex>
			</Flex>
		</Modal>
	)
}

export default ConfirmLeavePageModal;